import { Controller } from "@hotwired/stimulus"
import Coloris from "@melloware/coloris";
import "@melloware/coloris/dist/coloris.css"

// Connects to data-controller="color-picker-field"
export default class extends Controller {
  static targets = ['input']
  static values = { alpha: { type: Boolean, default: true } }

  connect() {
    Coloris.init()
    this.connectTargets()
  }

  connectTargets() {
    if(this.hasInputTarget) {
      this.inputTargets.forEach(input => Coloris({ el: `#${input.id}`, alpha: this.alphaValue }) )
    }
  }
}
